import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Utils
import dataHandler from "@Utils/dataHandler";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";
// modals
import ConfirmModal from "@Modals/ConfirmModal";
import PresetMessageCrud from "./Modals/PresetMessageCrud";

// Styles
import styles from "./styles.module.css";

const PresetMessage = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openPresentMessageCrud, setOpenPresentMessageCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [typesList, setTypesList] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [activeFilter, setActiveFilter] = useState("active");
	const activeFilterRef = useRef("active");

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15, isActive: 1 };
	const [queryParams, setQueryParams] = useState(defaultParams);

	useEffect(() => {
		(async () => {
			const presetMessagesPromise = dataHandler({
				dispatch,
				url: "presetMessages",
				params: queryParams,
			});
			const typesCategoryPromise = dispatch(genericAction({ method: "get", route: "types/messages" }));
			const [presetMessagesResponse, typesCategoryResponse] = await Promise.all([presetMessagesPromise, typesCategoryPromise]);

			setfilteredCount(presetMessagesResponse.count);
			setFilteredItems(presetMessagesResponse.items);
			setTypesList(typesCategoryResponse);
		})();
	}, []);

	// modal handler
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenPresentMessageCrud(true);
	};

	// table handler
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenPresentMessageCrud(false);
				break;

			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `presetMessages/${parseInt(tableValue.id, 10)}` }));
				break;
			default:
				break;
		}
		const presetMessagesResponse = await dataHandler({
			dispatch,
			url: "presetMessages",
			params: queryParams,
		});

		setfilteredCount(presetMessagesResponse.count);
		setFilteredItems(presetMessagesResponse.items);
	};
	// Table handlers
	const handlerData = async (params, printable) => {
		const finalParams = { ...params };
		if (activeFilterRef.current === "active") {
			finalParams.isActive = 1;
		} else if (activeFilterRef.current === "inactive") {
			finalParams.isActive = 0;
		} else {
			delete finalParams.isActive;
		}

		const data = await dataHandler({ dispatch, url: "presetMessages", params: finalParams });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
			setQueryParams(params);
		}
	};

	const handleStatusChange = (e, { value }) => {
		setActiveFilter(value);
		activeFilterRef.current = value;
		const newParams = { ...queryParams, page: 1 };
		if (value === "all") {
			delete newParams.isActive;
		} else {
			newParams.isActive = value === "active" ? 1 : 0;
		}
		handlerData(newParams);
	};

	const setRowStyle = (rowData) => {
		if (activeFilter === "all" && !rowData.isActive) {
			return { backgroundColor: "#ffcccc" };
		}
		return {};
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Mensajes Predeterminados">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Activo",
									key: "isActive",
									format: "boolean",
									boolLabels: { true: "Si", false: "No" },
									dataPosition: "center",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Título",
									key: "title",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},

								{
									label: "Texto",
									key: "text",
									format: "truncate",
									stringLength: 40,
									width: 3,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Tipo",
									key: "type.name",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Formato",
									key: "msgType",
									format: "string",
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},

								{
									label: "Adjunto",
									key: "uri",
									dataPosition: "center",
									format: "boolean",
									boolLabels: { true: "Si" },
									width: 1,
									canFilter: true,
									canSort: true,
									canPrint: true,
									canExcel: true,
									sortKey: null,
								},
								{
									label: "Creado Por",
									key: "user.fullName",
									dataPosition: "left",
									headerPosition: "left",
									format: "string",
									width: 15,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={queryParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							setRowStyle={setRowStyle}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem", hideOnMobile: true }}
							hidePrintButtons
							mobileCardView
							cardLine1={[
								{ key: "id", label: "ID" },
								{ key: "title", label: "Título" },
							]}
							cardLine2={[
								{ key: "text", label: "Texto" },
								{ key: "type.name", label: "Tipo" },
							]}
							cardLine3={[
								{ key: "msgType", label: "Formato" },
								{ key: "uri", label: "Adjunto" },
							]}
							cardLine4={[{ key: "user.fullName", label: "Creado Por" }]}
							printHeader={{
								company: companyName,
								title: "Mensajes Predeterminados",
								user: userName,
							}}
							topButtons={[
								{
									componentType: "DropDown",
									value: activeFilter,
									options: [
										{ key: "all", value: "all", text: "Todos" },
										{ key: "active", value: "active", text: "Activos" },
										{ key: "inactive", value: "inactive", text: "Inactivos" },
									],
									onChange: handleStatusChange,
								},
							]}
							print={{ printHeader: { company: companyName, title: "Mensajes Predeterminados", user: userName } }}
						/>

						{openPresentMessageCrud && (
							<PresetMessageCrud
								apiData={apiData}
								presetMessages={filteredItems}
								typesList={typesList}
								tableValue={tableValue}
								modalCrud={modalOption}
								onClose={() => {
									setOpenPresentMessageCrud(false);
								}}
							/>
						)}
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el Mensaje Predeterminado"
					focus={tableValue.title}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		agentsData: [],
		categoryData: [],
		companyName: company.name,
		userName: user.name,
	};
}
PresetMessage.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(PresetMessage);
